export enum Units {
  Hours = 'h',
  Kilograms = 'kg',
  Centimeters = 'cm',
}
